import { useState, useEffect} from "react";
import { API } from "../constant";
import { Link } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";
import logo3 from "../Media/LogoReverseWithTag.svg";
import Loading from "../Components/Hooks/Loading";
const Welcome = () =>{
    const { user } = useAuthContext();
    const[mydata, setmydata]=useState();
    const[loading, setLoading]=useState();
    
    useEffect(()=>{

        setLoading(true);
        fetch(`${API}/app-information?populate=*`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`Server error: ${res.status}`);
                }
                return res.json();
            })
            .then((data) => {
                setmydata([{
                    'title':data.data.attributes.app_title,
                    'logo':data.data.attributes.app_logo.data.attributes.url,
                    'logo1':data.data.attributes.logo_1.data.attributes.url,
                    'logo2':data.data.attributes.logo_2.data.attributes.url,
                    'logo3':data.data.attributes.logo_3.data.attributes.url,
                    'description':data.data.attributes.description[0].children[0].text
                }])
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching welcome screen data:", error);
                // Use default logo if backend is unavailable
                setLoading(false);
            });

    },[])
    // console.log(mydata);
    if(loading)
        return <Loading/>
    return(
        <div className="app-inner welcome">
            <div className="container">
                <div className="content-wrap bg-blue">
                    <div className="welcome-box">
                        <div className="logo mb---50 fade-in-down">
                            <img src={mydata!==undefined?mydata[0].logo3:logo3} alt="logo"/>
                        </div>
                        <div className="btn btn-bordered-gradient btn-full btn-large mb---10 btn-center delay-1">
                            <Link to={user ? "/" : "/register-intro"}>Create Account</Link>
                        </div>
                        <div className="btn btn-gradient btn-full btn-large btn-white mb---10 btn-center delay-2">
                            <Link to={user ? "/" : "/Login"}>Log in to Your Account</Link>
                        </div>
                        {/* <div className="btn btn-link btn-full btn-large btn-white mt---20">
                            <Link to={user ? "/" : "/Login"}>I will sign up later</Link>
                        </div> */}
                    </div>
                </div>
                
            </div>
        </div>
    );
}
export default Welcome;